import { useEffect } from "react";

import styles from './InterestForm.module.css';

const InterestForm = () => {
  useEffect(() => {
    const loadTally = () => {
      if (window.Tally) {
        window.Tally.loadEmbeds();
      }
    };

    // Script already loaded
    if (window.Tally) {
      loadTally();
      return;
    }

    // Script not loaded yet
    const existingScript = document.querySelector(
      'script[src="https://tally.so/widgets/embed.js"]'
    );

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://tally.so/widgets/embed.js";
      script.async = true;
      script.onload = loadTally;
      document.body.appendChild(script);
    } else {
      existingScript.addEventListener("load", loadTally);
    }
  }, []);

  return (
    <iframe
      id="tally-embed"
      className={`${styles.TallyForm} tally-embed`}
      data-tally-src="https://tally.so/r/Pd51ld"
      width="100%"
      height="1100"
      frameBorder="0"
      marginHeight="0"
      marginWidth="0"
      title="Interest Form"
    />
  );
};

export default InterestForm;